import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'prepareDate'})
export class PrepareDatePipe implements PipeTransform {
    transform(value: string): string {
        return value.replace(' ', 'T') + 'Z';
    }
}
